import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  location: string | null,
  name: string | null,
  description: string | null
} = {
  location: null,
  name: null,
  description: null
};

class FileInfoColorSpace extends Immutable.Record(Content) {
}

export default FileInfoColorSpace;
